"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Content = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Link = _interopRequireDefault(require("../typography/Link"));

var _IconContainer = _interopRequireDefault(require("../IconContainer"));

var _DesktopMenuItem = require("../NavBar/MenuItem/DesktopMenuItem");

var _SubmenuItem = _interopRequireDefault(require("./SubmenuItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Content = _styledComponents.default.div.withConfig({
  displayName: "Content",
  componentId: "sc-1n2emvi-0"
})(["display:flex;align-items:center;pointer-events:none;font-weight:", ";"], (0, _helpers.fontWeight)('regular'));

exports.Content = Content;

var SubmenuLinkComponent = function SubmenuLinkComponent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      Icon = _ref.icon,
      _ref$link = _ref.link,
      Link = _ref$link === void 0 ? _Link.default : _ref$link,
      to = _ref.to,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["children", "className", "icon", "link", "to", "onClick"]);

  var onClickWithBlur = function onClickWithBlur(event) {
    event && event.currentTarget && event.currentTarget.blur();

    if (onClick) {
      onClick(event);
    }
  };

  return _react.default.createElement(Link, _extends({
    to: to,
    className: className,
    onClick: onClickWithBlur
  }, props), _react.default.createElement(Content, null, Icon && _react.default.createElement(_IconContainer.default, null, _react.default.createElement(Icon, null)), Icon && children && _react.default.createElement(_DesktopMenuItem.Spacer, null), children));
};

var StyledLink = (0, _styledComponents.default)(SubmenuLinkComponent).withConfig({
  displayName: "StyledLink",
  componentId: "sc-1n2emvi-1"
})(["&&{padding:1rem;width:100%;color:", ";text-decoration:none;background-image:none;svg{color:", ";}&:hover,&:focus{background-image:none;background-color:", ";color:", ";svg{color:", ";}}}"], (0, _helpers.color)('black'), (0, _helpers.color)('dark-3'), (0, _helpers.color)('primary5'), (0, _helpers.color)('primary100'), (0, _helpers.color)('primary100'));

var SubmenuLink = function SubmenuLink(props) {
  return _react.default.createElement(_SubmenuItem.default, {
    className: "menuItem"
  }, _react.default.createElement(StyledLink, props));
};

var _default = SubmenuLink;
exports.default = _default;